const getInitialState = () => ({
  enabled: false,
  touchAndHold: false,
  holdKeyPressed: false,
  show: false,
  settings: {
    keys: '',
    useDarkTheme: false,
    isGhosting: true,
    showOutline: true,
    isHighlighting: true,
    hideNumberRow: true,
    touchAndHold: false,
    keyboardType: 'Keyboard35',
    roofs: false,
    showKeyboardAtStart: true
  },
  capsLock: false,
  capsLockSeverity: 'error',
  showSpecialKeys: false,
  topLevelInput: true
});

export default getInitialState;
